import React, { useEffect, useRef, useState } from "react";
import { Row, Col, Typography, Button, Tooltip } from "antd";
import "react-quill/dist/quill.snow.css";
import { FormOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setClientData } from "../../../../store/slices/OrgDetail";
import axiosInstance from "../../../../api/Axios";
import SelectedTemplateDetails from "./SelectedTemplateDetails";
import {
  capitalizeWords,
  formatDateWithSuffix,
} from "../../../../components/icons/ApplicationColor";
import {
  COURSE_TL_REDIRECTION,
  EVENT_TL_REDIRECTION,
  SESSION_TL_REDIRECTION,
} from "../../../../config";
const { Text } = Typography;
export const NotificationEmailType = ({ selectedNotification, origin }) => {
  console.log(selectedNotification, origin);
  const quillRef = useRef(null);
  const [emailSingleTemplate, setEmailSingleTemplate] = useState({});

  const LoadUser = async () => {
    try {
      const res = await axiosInstance.get(
        `/mailtemplate/${selectedNotification?.details?.template_id}/`
      );
      //console.log(res.data);
      setEmailSingleTemplate(res.data);
    } catch (err) {
      //console.log(err);
    }
  };

  useEffect(() => {
    if (selectedNotification?.details?.template_id) {
      LoadUser();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div
        className="my-form-lables"
        style={{
          marginBottom: "15px",
          paddingInline: "5px",
          fontSize: "14.75px",
          fontWeight: "500",
        }}
      >
        {capitalizeWords("EMAIL INFORMATION")} :
      </div>
      {origin !== "USER" ? (
        <>
          <Row gutter={16} style={{ marginBottom: "17.5px" }}>
            <Col span={12}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Text className="text-name-styles-headings">
                  TEMPLATE USED :
                </Text>
                <Text className="text-name-styles">
                  {selectedNotification?.details?.template}
                </Text>
              </div>
            </Col>

            <Col span={12}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Text className="text-name-styles-headings">
                  RECEIVING ID :
                </Text>

                <Text className="text-name-styles">
                  {Array.isArray(selectedNotification?.receivedBy) &&
                    (selectedNotification.receivedBy.length === 1
                      ? selectedNotification.receivedBy[0]?.email
                      : `${selectedNotification.receivedBy[0]?.email} and ${
                          selectedNotification.receivedBy.length - 1
                        } others`)}
                </Text>
              </div>
            </Col>
          </Row>
          <Row gutter={16} style={{ marginBottom: "17.5px" }}>
            <Col span={24}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Text className="text-name-styles-headings">
                  EMAIL SUBJECT :
                </Text>
                <Text className="text-name-styles">
                  {selectedNotification?.details?.subject}
                </Text>
              </div>
            </Col>
          </Row>
          {emailSingleTemplate?.body && (
            <SelectedTemplateDetails
              quillRef={quillRef}
              emailSingleTemplate={emailSingleTemplate}
              dataPassed={selectedNotification?.details}
              from={"notifications"}
            />
          )}
        </>
      ) : (
        <>
          <Row gutter={16} style={{ marginBottom: "17.5px" }}>
            <Col span={12}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Text className="text-name-styles-headings">
                  Email Subject :
                </Text>
                <Text className="text-name-styles">
                  {selectedNotification?.details?.subject}
                </Text>
              </div>
            </Col>

            <Col span={12}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Text className="text-name-styles-headings">
                  Receiving ID :
                </Text>

                <Text className="text-name-styles">
                  {Array.isArray(selectedNotification?.receivedBy) &&
                    (selectedNotification.receivedBy.length === 1
                      ? selectedNotification.receivedBy[0]?.email
                      : `${selectedNotification.receivedBy[0]?.email} and ${
                          selectedNotification.receivedBy.length - 1
                        } others`)}
                </Text>
              </div>
            </Col>
          </Row>

          {selectedNotification?.mail_content?.course_id && (
            <Row gutter={16} style={{ marginBottom: "25px" }}>
              <Col span={5}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Text className="text-name-styles-headings">Course ID:</Text>

                  <Tooltip title="Click to know more about the course">
                    <Text
                      className="text-name-styles"
                      style={{
                        cursor: "pointer",
                        color: "blue",
                        textDecoration: "underline",
                      }}
                      onClick={() =>
                        window.open(
                          `${COURSE_TL_REDIRECTION}/${selectedNotification?.mail_content?.course_pk}`,
                          "_blank"
                        )
                      }
                    >
                      {selectedNotification?.mail_content?.course_id}
                    </Text>
                  </Tooltip>
                </div>
              </Col>
              <Col span={7}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Text className="text-name-styles-headings">
                    Course Name:
                  </Text>
                  <Tooltip title="Click to know more about the course">
                    <Text
                      className="text-name-styles"
                      style={{
                        cursor: "pointer",
                        color: "blue",
                        textDecoration: "underline",
                      }}
                      onClick={() =>
                        window.open(
                          `${COURSE_TL_REDIRECTION}/${selectedNotification?.mail_content?.course_pk}`,
                          "_blank"
                        )
                      }
                    >
                      {selectedNotification?.mail_content?.course_name}
                    </Text>
                  </Tooltip>
                </div>
              </Col>
              <Col span={6}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Text className="text-name-styles-headings">Event ID:</Text>
                  <Tooltip title="Click to know more about the Event">
                    <Text
                      className="text-name-styles"
                      style={{
                        cursor: "pointer",
                        color: "blue",
                        textDecoration: "underline",
                      }}
                      onClick={() =>
                        window.open(
                          `${EVENT_TL_REDIRECTION}/${selectedNotification?.mail_content?.event_pk}`,
                          "_blank"
                        )
                      }
                    >
                      {selectedNotification?.mail_content?.event_id}
                    </Text>
                  </Tooltip>
                </div>
              </Col>
              <Col span={6}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Text className="text-name-styles-headings">Session ID:</Text>
                  <Tooltip title="Click to know more about the Session">
                    <Text
                      className="text-name-styles"
                      style={{
                        cursor: "pointer",
                        color: "blue",
                        textDecoration: "underline",
                      }}
                      onClick={() =>
                        window.open(
                          `${SESSION_TL_REDIRECTION}/${selectedNotification?.mail_content?.session_pk}`,
                          "_blank"
                        )
                      }
                    >
                      {selectedNotification?.mail_content?.session_id}
                    </Text>
                  </Tooltip>
                </div>
              </Col>
            </Row>
          )}
          {selectedNotification?.details?.body && (
            <SelectedTemplateDetails
              quillRef={quillRef}
              emailSingleTemplate={selectedNotification?.details}
              dataPassed={selectedNotification?.details}
              from={"notifications"}
              origin={origin}
            />
          )}
        </>
      )}
    </div>
  );
};

export const NotificationSubType = ({ selectedNotification, origin }) => {
  const history = useNavigate();
  const dispatch = useDispatch();

  const { client_id, client, start_date, end_date, subscription_id } =
    selectedNotification?.details;
  const redirectTnAdmin = (id) => {
    dispatch(
      setClientData({
        client_id,
        name: client,
        contract_start_date: start_date,
        contract_end_date: end_date,
      })
    );
    history(`/admin-manager/clients/sub/${id}`);
  };

  return (
    <div>
      <div
        className="my-form-lables"
        style={{
          marginBottom: "15px",
          paddingInline: "5px",
          fontSize: "14.75px",
          fontWeight: "500",
        }}
      >
        SUBSCRIPTION INFORMATION :
      </div>
      <Row gutter={16} style={{ marginBottom: "17.5px" }}>
        <Col span={12}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Text className="text-name-styles-headings">Name :</Text>
            <Text className="text-name-styles">{client}</Text>
          </div>
        </Col>
        <Col span={12}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Text className="text-name-styles-headings">Client ID :</Text>
            <Text className="text-name-styles">{client_id}</Text>
          </div>
        </Col>
      </Row>
      <Row gutter={16} style={{ marginBottom: "17.5px" }}>
        <Col span={12}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Text className="text-name-styles-headings">Start Date :</Text>
            <Text className="text-name-styles">
              {formatDateWithSuffix(start_date)}
            </Text>
          </div>
        </Col>
        <Col span={12}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Text className="text-name-styles-headings">End Date :</Text>
            <Text className="text-name-styles">
              {formatDateWithSuffix(end_date)}
            </Text>
          </div>
        </Col>
      </Row>
      <div
        className="my-form-lables"
        style={{
          marginTop: "35px",
          marginBottom: "7.5px",
          paddingInline: "5px",
          fontSize: "14px",
          fontWeight: "500",
          //   textDecoration: "underline",
        }}
      >
        MESSAGE CONTENT :
      </div>
      <Row gutter={16} style={{ marginBottom: "17.5px", marginTop: "20px" }}>
        <Col span={24}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: "16px",
            }}
          >
            <Text
              className="text-name-styles"
              style={{ fontSize: "14px", textAlign: "center", width: "100%" }}
            >
              {selectedNotification?.content}
            </Text>
          </div>
        </Col>
      </Row>
      {origin === "TN_ADMIN" && (
        <Row
          gutter={16}
          justify="center"
          align="middle"
          style={{
            marginBottom: "17.5px",
            marginTop: "20px",
            marginInline: "20px",
          }}
        >
          <Button
            style={{ fontSize: "13px", fontFamily: "Poppins" }}
            onClick={() => redirectTnAdmin(subscription_id)}
            type="primary"
          >
            Change Subscription
            <FormOutlined />
          </Button>
        </Row>
      )}
    </div>
  );
};
